import { NotFoundIllustration } from './../../ui/illustrations/NotFoundIllustration';
import { Link } from 'react-router-dom';  // Import Link component
import './NotFound.scss';

const NotFound = () => {
  return (
    <>
      <div className="not-found-wrapper">
        <NotFoundIllustration />
        <Link to="/" className="cta-filled centered">
          Homepage
        </Link>
      </div>
    </>
  );
};

export default NotFound;